// Ported verbatim from WOOF1_eCRF_v7.html (source line 1627, const VISIT_CONFIG).
export interface VisitConfigEntry {
  vk: string;
  num: number;
  label: string;
  day: string;
  window: string;
  virtual?: boolean;
}

export const VISIT_CONFIG: VisitConfigEntry[] = [
  { vk: "V0", num: 1, label: "Sélection", day: "J-30 à J-15", window: "" },
  { vk: "V1", num: 2, label: "Inclusion + Injection", day: "J1 T0", window: "" },
  { vk: "V1b", num: 2, label: "Post-injection 6h", day: "J1 +6h", window: "" },
  { vk: "V2", num: 3, label: "Suivi", day: "J7", window: "±2j" },
  { vk: "V3", num: 4, label: "Suivi", day: "J15", window: "±3j" },
  { vk: "V4", num: 5, label: "Évaluation + 2ème injection", day: "J30", window: "±7j" },
  { vk: "V5", num: 6, label: "Suivi", day: "J60", window: "±7j" },
  { vk: "V6", num: 7, label: "Évaluation + 3ème injection", day: "J90", window: "±7j" },
  { vk: "V7", num: 8, label: "Suivi", day: "J120", window: "±7j" },
  { vk: "V8", num: 9, label: "Suivi", day: "J150", window: "±7j" },
  { vk: "V9", num: 10, label: "Évaluation finale", day: "J180", window: "±7j" },
  { vk: "EoS", num: 11, label: "Fin d'étude", day: "—", window: "" },
  // Virtual hub tabs - not real visits, UI aggregation views only.
  { vk: "AS", num: 12, label: "Admins suppl.", day: "Extension", window: "", virtual: true },
  { vk: "VS", num: 13, label: "Visites suppl.", day: "Extension", window: "", virtual: true },
];

export const REAL_VISIT_KEYS = VISIT_CONFIG.filter((v) => !v.virtual).map((v) => v.vk);

// iRECIST/drug-admin visit chronology, source: getPrevIRECISTResponse / renderIRECISTSection.
export const IRECIST_VISIT_ORDER = ["V1", "V4", "V6", "V9"];
export const IRECIST_DEFAULT_TIMEPOINT: Record<string, string> = {
  V1: "Baseline",
  V4: "D30",
  V6: "D90",
  V9: "D180",
};
export const DRUG_ADMIN_VISITS = ["V1", "V4", "V6"];
export const CYTOKINES_VISITS = ["V1", "V2", "V3"];
export const IRECIST_VISITS = ["V1", "V4", "V6", "V9"]; // + extras, handled dynamically

export function isExtraVisitKey(vk: string, knownKeys: string[] = REAL_VISIT_KEYS): boolean {
  return /^V[1-9][0-9]+$/.test(vk) && !knownKeys.includes(vk);
}
